<div class="screen">
  <div class="screen-inner">
    <app-shell nav="close" action="none" title="New payout" [backTo]="backTo"></app-shell>

    @if (dashboard) {
      <form class="form" (ngSubmit)="save()">
        <label class="field">
          <span class="field-label">Place</span>
          <input name="place" type="number" inputmode="numeric" min="1" [(ngModel)]="place" />
        </label>

        <label class="field">
          <span class="field-label">Amount</span>
          <input name="amount" type="number" inputmode="decimal" step="0.01" [(ngModel)]="amount" />
          @if (fieldErrors['amount']) { <span class="field-error">{{ fieldErrors['amount'] }}</span> }
        </label>

        <label class="field">
          <span class="field-label">Who gets it</span>
          <select name="userId" [(ngModel)]="userId">
            <option [ngValue]="null">Decide later</option>
            @for (player of dashboard.registrations; track player.userId) {
              <option [ngValue]="player.userId">{{ player.displayName }}</option>
            }
          </select>
        </label>

        <label class="field">
          <span class="field-label">Note</span>
          <input name="description" [(ngModel)]="description" placeholder="Closest to the pin, hole 7" />
        </label>

        @if (error) { <p class="error">{{ error }}</p> }

        <button class="btn-primary" type="submit" [disabled]="busy">Save payout</button>
      </form>
    }
  </div>
</div>
